<template>
    <div class="d-flex ga-5">
        <div class="image-input-container-image">
            <v-img :width="100" :height="100" aspect-ratio="1/1"
                :src="uploadedImage ? imagePreview : require('@/ai_studio/assets/icons/empty-background.svg')" cover></v-img>
        </div>

        <div class="image-input-container-text d-flex flex-column align-start ga-2">
            <p v-html="props.description"></p>
            <div class="d-flex ga-2">
                <v-btn class="px-6 py-5 d-flex" rounded="xl" elevation="0" color="primary-60" @click="fileInput.click()">Enviar imagem</v-btn>
                <v-btn class="px-6 py-5 d-flex" rounded="xl" variant="outlined" color="neutral-35" @click="removeImage"
                    :disabled="!uploadedImage">Remover</v-btn>
                <input type="file" ref="fileInput" :accept="validFilesTypes" style="display: none"
                    @change="sendFile" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import { useSnackbarStore } from '@/ai_studio/stores/snackbar';
const snackbar = useSnackbarStore();
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: { type: [String, File], default: null },
    maxSizeMegaBytes: { type: Number, default: 2 },
    description: { type: String, default: 'A dimensão recomendada é 250x50 <br> Formato <b>PNG</b>, <b>JPG</b> ou <b>JPEG de no máximo 2MB</b> Imagens com dimensões diferentes serão redimensionadas.' }
});

const uploadedImage = ref(!!props.modelValue);
const imagePreview = ref(props.modelValue || '');
const fileInput = ref(null);
const validFilesTypes = ['image/jpeg', 'image/jpg', 'image/png'];

const sendFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (!validFilesTypes.includes(file.type)) {
        snackbar.error('Formato de arquivo não suportado.');
        fileInput.value.value = '';
        return;
    }
    if (file.size > props.maxSizeMegaBytes * 1024 * 1024) {
        snackbar.error(`O arquivo excede o tamanho máximo de ${props.maxSizeMegaBytes}MB.`);
        fileInput.value.value = '';
        return;
    }
    imagePreview.value = URL.createObjectURL(file);
    uploadedImage.value = true;
    emit('update:modelValue', file);
};

const removeImage = () => {
    uploadedImage.value = false;
    imagePreview.value = '';
    fileInput.value.value = '';
    emit('update:modelValue', null);
};

watch(() => props.modelValue, (value) => {
    uploadedImage.value = !!value;
    if (value) return imagePreview.value = typeof value === 'string' ? value : URL.createObjectURL(value);
    imagePreview.value = '';
});
</script>

<style scoped>
.image-input-container-text {
    width: 320px;
    height: fit-content;
}

.image-input-container-text p {
    font-family: Roboto;
    font-size: 14px;
    color: rgb(var(--v-theme-neutral-35));
    text-align: start;
}
</style>